export default "/images/vendor/flag-icon-css/flags/1x1/li.svg?12116067e3566ce346e3a8faf01f617a";